import { AppState } from '../store';

export function getLocalisation(state: AppState) {
  return state.localisation;
}

export function getBrandName(state: AppState) {
  return state.localisation.brandConfig?.name;
}
